<template>
    <!--<fieldset>
        <legend>Addresses</legend>
        <div>
            <addressEditor  v-for="item in controller.items" :controller="item"></addressEditor>
        </div>
        <button class="col-md-offset-3 btn btn-default" @click="this.controller.addNew">Add</button>
    </fieldset>-->
</template>
<script>
    import addressEditor from "./addressEditor.scp.html"
    import forminput from "./../../corecontrols/forminput/forminput.scp.html"
    import { AddressGroupController } from './addressGroupEditorController'
    import { AddressDto } from './../../../dto/address'


    export default {
        props: ['addresses'],

        data: function () {
            return {
                controller: new AddressGroupController()
            }
        },
        mounted: function () {
            if (this.addresses) {
                this.controller = new AddressGroupController(this.addresses)
            }
        },
        components:{
            addressEditor
        }
    }
</script>




// WEBPACK FOOTER //
// addressGroupEditor.scp.html?e48b5d2c